$(document).ready(function () {
    const field = $('#search-field');
    if (!(field.length !== 0 && field.ghostHunter)) {
        return;
    }
    const resultTemplate = `<a id='gh-{{ref}}' class='gh-search-item' href='{{link}}'>{{title}}</a>`;

    const results = $('#search-results');

    field.ghostHunter({
        results: results,
        onKeyUp: true,
        includebodysearch: true,
        onPageLoad: true,
        onComplete: () => {
            results.show();
        },
        result_template: resultTemplate,
        info_template: `<p class="search-info search-{{amount}}">Post not found. Please try other keywords.</p>`,
    });

    $('body').on('click', (e) => {
        if (!e.target.closest('#search-section')) {
            results.hide();
        }
    });
});
